module.exports = __webpack_public_path__ + "img/apoio-guyra.b6736592.png";